import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';
import './socialShareIcons.scss';

export type SocialShareIconsProps = {
  url: string;
};

export const SocialShareIcons: React.FC<SocialShareIconsProps> = ({
  url = '/',
}) => (
  <aside className="social-share-icons">
    {[
      { Button: FacebookShareButton, Icon: FacebookIcon },
      { Button: TwitterShareButton, Icon: TwitterIcon },
      { Button: LinkedinShareButton, Icon: LinkedinIcon },
      { Button: EmailShareButton, Icon: EmailIcon },
    ].map(({ Button, Icon }, i) => (
      <i key={i} className="social-share-icons__icon no-print">
        <Button url={url}>
          <Icon size={32} round />
        </Button>
      </i>
    ))}
  </aside>
);
